import React, { useEffect, useState } from "react";
import { Grid, Card } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EmptyData from "components/EmptyData";
import apiClient from "../../Utils/apiClient";

// Legacy Firebase implementation kept for reference during the backend migration:
// const database = getDatabase();
// const usersRef = ref(database, "/users");
// const snapshot = await get(usersRef);

const commonHeaderStyle = { color: "blue", fontWeight: "bold" };

const columns = [
  { Header: <span style={commonHeaderStyle}>SR</span>, accessor: "SR", align: "center" },
  { Header: <span style={commonHeaderStyle}>Name</span>, accessor: "Name", align: "center" },
  { Header: <span style={commonHeaderStyle}>Number</span>, accessor: "Number", align: "center" },
  { Header: <span style={commonHeaderStyle}>Pin No</span>, accessor: "Pin", align: "center" },
  { Header: <span style={commonHeaderStyle}>Image</span>, accessor: "Image", align: "center" },
  { Header: <span style={commonHeaderStyle}>Action</span>, accessor: "action", align: "center" },
];

function RegisteredVehicle() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getVehicleImage = (vehicle) =>
    vehicle?.images?.[0] || vehicle?.image || vehicle?.vehicleImage || vehicle?.imgVehicle || "";

  const getData = async () => {
    console.log("[RegisteredVehicle] getData() started");
    setLoading(true);
    setRows([]);

    try {
      const storedUser = localStorage.getItem("user");
      console.log("[RegisteredVehicle] localStorage user:", storedUser);

      if (!storedUser) {
        console.log("[RegisteredVehicle] no stored user, redirecting to sign-in");
        navigate("/authentication/sign-in");
        return;
      }

      const response = await apiClient.get("/vehicles", {
        params: {
          page: 1,
          limit: 100,
        },
      });

      console.log("[RegisteredVehicle] /vehicles response:", response);

      const vehicles = Array.isArray(response?.data) ? response.data : [];
      console.log("[RegisteredVehicle] vehicles count:", vehicles.length);
      console.log(
        "[RegisteredVehicle] first few vehicles:",
        vehicles.slice(0, 5).map((vehicle) => ({
          id: vehicle?._id,
          userId: vehicle?.userId,
          vehicleNickname: vehicle?.vehicleNickname,
          ownerName: vehicle?.ownerName,
          licensePlate: vehicle?.licensePlate,
          imei: vehicle?.imei,
        })),
      );

      const mappedRows = vehicles.map((vehicle, index) => {
        const name = vehicle?.vehicleNickname || vehicle?.ownerName || "N/A";
        const number = vehicle?.licensePlate || vehicle?.regNo || "N/A";
        const pin = vehicle?.imei || vehicle?.chassisNumber || "N/A";
        const imageUrl = getVehicleImage(vehicle);
        const trackUserId = vehicle?.userId || vehicle?.userObjectKey || vehicle?.ownerId || "";

        return {
          SR: index + 1,
          Name: name,
          Number: number,
          Pin: pin,
          Image: imageUrl ? (
            <img
              src={imageUrl}
              alt={name}
              style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <MDTypography variant="caption" color="text">
              N/A
            </MDTypography>
          ),
          action: trackUserId ? <Link to={`/locate/${trackUserId}?userData=truck`}>Track</Link> : "N/A",
        };
      });

      console.log("[RegisteredVehicle] mappedRows count:", mappedRows.length);
      setRows(mappedRows);
    } catch (error) {
      console.error("[RegisteredVehicle] failed to fetch vehicles:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("[RegisteredVehicle] mounted");
    getData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Vehicles
                  </MDTypography>
                </MDBox>

                <MDBox pt={3}>
                  {rows.length > 0 ? (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  ) : (
                    <EmptyData />
                  )}
                </MDBox>
              </Card>
            </Grid>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default RegisteredVehicle;
